import useAxios from './AxiosConfig';

export const PasswordResetService = () => {
    const axios = useAxios();

    const resetPassword = async (newPassword) => {
        try {
            const response = await axios.post('/reset-password', {
                newPassword: newPassword
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    const validatePassword = (password) => {
        const errors = [];
        
        if (password.length < 8) {
            errors.push('Password must be at least 8 characters long');
        }
        
        if (!/[A-Z]/.test(password)) {
            errors.push('Password must contain at least one uppercase letter');
        }
        
        if (!/[a-z]/.test(password)) {
            errors.push('Password must contain at least one lowercase letter');
        }
        
        if (!/\d/.test(password)) {
            errors.push('Password must contain at least one number');
        }
        
        if (!/[!@#$%^&*]/.test(password)) {
            errors.push('Password must contain at least one special character (!@#$%^&*)');
        }
        
        return {
            isValid: errors.length === 0,
            errors: errors
        };
    };

    const getPasswordStrength = (password) => {
        let score = 0;
        const feedback = [];

        if (password.length >= 8) {
            score += 1;
        } else {
            feedback.push('At least 8 characters');
        }

        if (/[A-Z]/.test(password)) {
            score += 1;
        } else {
            feedback.push('At least one uppercase letter');
        }

        if (/[a-z]/.test(password)) {
            score += 1;
        } else {
            feedback.push('At least one lowercase letter');
        }

        if (/\d/.test(password)) {
            score += 1;
        } else {
            feedback.push('At least one number');
        }

        if (/[!@#$%^&*]/.test(password)) {
            score += 1;
        } else {
            feedback.push('At least one special character (!@#$%^&*)');
        }

        let strength = 'Weak';
        if (score >= 4) strength = 'Strong';
        else if (score >= 3) strength = 'Good';
        else if (score >= 2) strength = 'Fair';

        return {
            score,
            strength,
            feedback
        };
    };

    return {
        resetPassword,
        validatePassword,
        getPasswordStrength
    };
};

export default PasswordResetService;
